import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star, Gift, Flower2 } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function AudienceSection() {
  const {
    t
  } = useTranslation();
  const icons = [<Heart className="w-6 h-6 text-blush-500" key="h" data-id="element-17" />, <Star className="w-6 h-6 text-gold-500" key="s" data-id="element-18" />, <Gift className="w-6 h-6 text-lavender-500" key="g" data-id="element-19" />, <Flower2 className="w-6 h-6 text-blush-600" key="f" data-id="element-20" />];
  const audiences = t.audience.items.map((text, i) => ({
    icon: icons[i],
    text
  }));
  return <section className="py-20 bg-white" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-23">
          <h2 className="font-serif text-4xl text-gray-900 mb-4" data-id="element-24">
            {t.audience.heading}
          </h2>
          <div className="w-24 h-1 bg-lavender-200 mx-auto rounded-full" data-id="element-25"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-26">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-50 rounded-2xl p-8 text-center border border-lavender-50 hover:border-lavender-200 transition-colors group" data-id="element-27">
              <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-28">
                {item.icon}
              </div>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-29">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}